function WhistlePage(){
	var me = this;
	this.id = function(){
		var id = me.constructor.name;
		return id.charAt(0).toLowerCase() + id.slice(1);
	}
	 
}